import { AppState } from '../initialStateRegistration';

export const getSecondaryHeader = (state:AppState) => state.secondaryHeader;
